export const removeFalsey = (items) => items.filter(Boolean);
//# sourceMappingURL=removeFalsey.js.map